/**
 * Consent Manager: DSGVO-konform
 * - Speichert Auswahl in localStorage (pb24_consent, 6 Monate gültig)
 * - Lädt GA4 & Meta Pixel NUR nach expliziter Einwilligung
 * - IDs kommen aus ENV: REACT_APP_GA4_ID + REACT_APP_META_PIXEL_ID
 */

const STORAGE_KEY = "pb24_consent";
const CONSENT_TTL_DAYS = 180;

export const CONSENT_DEFAULTS = {
  necessary: true, // immer an
  analytics: false,
  marketing: false,
  ts: null,
};

export function readConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed.ts) return null;
    const ageDays = (Date.now() - parsed.ts) / (1000 * 60 * 60 * 24);
    if (ageDays > CONSENT_TTL_DAYS) return null;
    return { ...CONSENT_DEFAULTS, ...parsed };
  } catch {
    return null;
  }
}

export function writeConsent(consent) {
  const payload = { ...CONSENT_DEFAULTS, ...consent, ts: Date.now() };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  applyConsent(payload);
  window.dispatchEvent(new CustomEvent("pb24-consent-changed", { detail: payload }));
  return payload;
}

export function clearConsent() {
  localStorage.removeItem(STORAGE_KEY);
  window.location.reload();
}

// ---------- Loaders ---------- //
// Session 31 · Legacy-Bootstraps bleiben als Compat-Wrapper erhalten, delegieren
// jedoch an die neuen zentralen Loader unter /lib/tracking/. Der einzige gültige
// Einstiegspunkt ist ab jetzt der `dispatcher.initTracking()`-Boot. Diese
// Funktionen werden nur behalten, um die bestehende Public-API stabil zu halten;
// echte Consent-Sync + Consent-Mode v2 laufen über das `pb24-consent-changed`-Event.
function loadGA4(_id) { /* delegated to /lib/tracking/gtag via dispatcher */ }
function loadMetaPixel(_id) { /* delegated to /lib/tracking/fbq via dispatcher */ }

// ---------- Apply / Boot ---------- //

export function applyConsent(consent) {
  const c = consent || readConsent();
  if (!c) return;
  // Session 31 · Der neue Dispatcher hört auf `pb24-consent-changed` und
  // synchronisiert Loader + Consent-Mode-v2. Wir tun hier bewusst nichts mehr
  //: keine parallelen Skript-Injections, um Doppel-Loads zu vermeiden.
}

/** Beim Start des SPA: falls bereits ein gültiges Consent existiert, Tracker booten. */
export function bootConsent() {
  const c = readConsent();
  if (c) applyConsent(c);
}
